// extracted by mini-css-extract-plugin
module.exports = {"background":"EventsAndAlerts_background__48tAQ","contentWrapper":"EventsAndAlerts_contentWrapper__4bJLG"};